<div *ngIf="isAssetLoading">
    <app-table-data-loader></app-table-data-loader>
</div>
<div *ngIf="!isAssetLoading">
    <div *ngIf="assetDetailList?.length > 0">
        <div class="custom-scroller">
        <mat-card class="mb-3 mat-elevation-z0 align-items-center d-flex w-100 justify-content-between"
                  *ngFor="let asset of assetDetailList" (click)="selectAsset(asset.id)"
                  [ngClass]="asset.isSelected ? 'blue' : ''">
          <div class="container-fluid">
            <div class="row font-weight-bold">
              <div class="col-12 col-md-2 asset-name-col fw-bold">Asset Name</div>
              <div class="col-12 col-md-2 manufacturer-col fw-bold">Manufacturer</div>
              <div class="col-12 col-md-1 model-col fw-bold">Model</div>
              <div class="col-12 col-md-1 barcode-col fw-bold">Barcode</div>
              <div class="col-12 col-md-2 date-col fw-bold">Date of Purchase</div>
              <div class="col-12 col-md-2 lifetime-col fw-bold">Useful Lifetime (years)</div>
              <div class="col-12 col-md-2 maintenance-col fw-bold">Maintenance Cycle</div>
            </div>
            <div class="row">
              <div class="col-12 col-md-2 asset-name-col">{{asset.assetName}}</div>
              <div class="col-12 col-md-2 manufacturer-col">{{asset.make}}</div>
              <div class="col-12 col-md-1 model-col">{{asset.model}}</div>
              <div class="col-12 col-md-1 barcode-col">{{asset.barcode}}</div>
              <div class="col-12 col-md-2 date-col">{{asset.dateOfPurchase | date:'dd MMM yyyy'}}</div>
              <div class="col-12 col-md-2 lifetime-col">{{asset.usefulLife}}</div>
              <div class="col-12 col-md-2 maintenance-col">{{maintenanceCycleLabel(asset?.maintenanceCycle)}}</div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button class="common-button mat-elevation-z0 black me-2 mat-button-toggle-label-content border-0"
                    (click)="view(asset.id)">View</button>
          </div>
        </mat-card>
    </div>
      </div>
    <mat-paginator *ngIf="assetDetailList?.length > 0" [length]="totalPage" [pageSize]="pageSize"
        [showFirstLastButtons]="true" aria-label="Select page" [hidePageSize]="true" (page)="getPaginatedResult($event)"
        [pageIndex]="pageNumber">
    </mat-paginator>
    <mat-card class="mat-elevation-z0" *ngIf="assetDetailList == null || assetDetailList?.length == 0">
        <div
            class="no-jobs-indicator d-flex flex-column align-items-center justify-contet-center text-center mt-5 pt-5">
            <img src="../../../../assets/images/empty-box-open.png" width="100" />
            <h2 class="font-poppins font-semibold mb-5 mt-4 font-25 mb-3">No assets found!</h2>
        </div>
    </mat-card>
</div>
<div *ngIf="isAssetView">
    <app-asset-detail-with-backdrop [selectedAssetId]="selectedAssetId" (closeAssetDetails)="closeAssetDetails()"
        [assetStatus]="selectedAssetCategory">
    </app-asset-detail-with-backdrop>
</div>